/**
 * 로그인 후 돌아갈 경로 — 같은 사이트 안의 경로만 허용한다 (//evil.com 같은 외부 주소 차단).
 * 로그인 화면 자신으로 돌아가는 것도 막는다.
 */
export function safeRedirectPath(value: string | undefined): string {
  if (!value?.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  if (value === '/login' || value.startsWith('/login?')) return '/';
  return value;
}
